export default {
  install(Vue, options) {
    Vue.prototype.$i18n_en = options.i18n_en
    Vue.prototype.$i18n_fr = options.i18n_fr
  },
}
